module.exports = "/_next/static/images/2a95d68e2a597fed89984b12e5f74c20-cross-circle.svg";